<template>
    <div class="container d-flex justify-content-center align-items-center horizontal-scrollable flex-column">

        <h4 class="display-6 text-center mb-4 mt-4">
            Mora de Créditos
            <br>
            {{ etiquetaRango || 'Créditos en Mora' }}
        </h4>

        <table class="table table-striped table-hover" id="myTable">
            <thead>
                <tr>
                    <th>Index</th>
                    <th>Beneficiario</th>
                    <th class="text-center">DNI</th>
                    <th>Saldo Capital</th>
                    <th>Saldo Interes corriente (A la fecha)</th>
                    <th class="text-center">Saldo Intereres Moratorio(A la fecha)</th>
                    <th>Total Saldo Vencido a pagar(A la fecha)</th>
                    <th>Total Saldo a pagar  para cancelación(A la fecha)</th>
                    <th>Asesor</th>
                </tr>
            </thead>

            <tbody v-if="ready">
                <tr @click="irCredito(credito.cliente.dni)" v-for="(credito, index) in creditosSafe" :key="credito.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ credito.cliente.nombres }}</td>
                    <td>{{ credito.cliente.dni }}</td>
                    <td>{{ formatoNumero(credito.saldo) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy?.saldoInteres || 0) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy?.saldoMora || 0) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy.capitalDebePagar + (credito.simularPagoHoy?.saldoInteres || 0) +
                        (credito.simularPagoHoy?.saldoMora || 0)) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.saldo + (credito.simularPagoHoy?.saldoInteres || 0) +
                        (credito.simularPagoHoy?.saldoMora || 0)) }} {{ moneda }}</td>
                    <td> {{credito.nombreAsesor}} </td>
                </tr>
            </tbody>

            <tbody v-else>
                <tr>
                    <td colspan="10" class="text-center">
                        <div class="spinner-border text-warning text-center" role="status">
                            <span class="visually-hidden text-center">Loading...</span>
                        </div>
                    </td>
                </tr>
            </tbody>

            <tfoot v-if="ready">
                <tr class="table-dark">
                    <td colspan="3" class="text-end"><strong>Totales:</strong></td>
                    <td>{{ formatoNumero(totalCapital) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalInteres) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalMora) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalAdeudado) }} {{ moneda }}</td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import { store } from '../store'
import DataTables from 'datatables.net'
import Security from '../security'

export default {
    name: 'TablaCreditosMora',

    data() {
        return {
            creditos: [],
            rango: '',
            etiqueta: '',
            ready: false,
            moneda: 'Lps'
        }
    },

    created() {
        // this.creditos = store.creditos


        // this.ready = true
    },
    beforeMount(){

       

    },

    mounted() {


            store.rango = this.normalizarRangoMora(this.$route.query.rango || '')
            store.etiqueta = this.$route.query.etiqueta || this.etiquetaRangoMora(store.rango)
            store.sucursalSeleccionada = this.$route.query.sucursal || ''
            store.asesorSeleccionado = this.normalizarEntero(this.$route.query.asesor, 0)
            store.tipoCarteraSeleccionado = this.normalizarEntero(this.$route.query.tipoCartera, 0)
            store.estadoSeleccionado = this.$route.query.estado || ''
            this.rango = store.rango
            this.etiqueta = store.etiqueta

            console.log('Parámetros de consulta:', {
                etiqueta: store.etiqueta,
                rango: store.rango,
                sucursal: store.sucursalSeleccionada,
                asesor: store.asesorSeleccionado,
                tipoCartera: store.tipoCarteraSeleccionado,
                estado: store.estadoSeleccionado
            })

           fetch(process.env.VUE_APP_API_URL + "/admin/credito/credito-mora", Security.requestOptions({ 
            sucursal: store.sucursalSeleccionada, 
            asesor: store.asesorSeleccionado, 
            tipoCartera: store.tipoCarteraSeleccionado, 
            estado: store.estadoSeleccionado, 
            rango: store.rango }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {

            console.log(response.data);
            this.creditos = Array.isArray(response.data?.creditos) ? response.data.creditos : [];

            this.ready = true;
            this.$nextTick(() => {
                        this.initializeDataTable()
                    })
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })


    },

    computed: {
        creditosSafe() {
            return Array.isArray(this.creditos) ? this.creditos : []
        },
        etiquetaRango() {
            return this.etiqueta || store.etiqueta || this.etiquetaRangoMora(this.rango || store.rango)
        },
        totalCapital() {
            return this.creditosSafe.reduce((s, c) => s + (c.saldo || 0), 0)
        },
        totalInteres() {
            return this.creditosSafe.reduce((s, c) => s + (c.simularPagoHoy?.saldoInteres || 0), 0)
        },
        totalMora() {
            return this.creditosSafe.reduce((s, c) => s + (c.simularPagoHoy?.saldoMora || 0), 0)
        },
        totalAdeudado() {
            return this.creditosSafe.reduce(
                (s, c) =>
                    s + (c.saldo || 0) + (c.simularPagoHoy?.saldoInteres || 0) + (c.simularPagoHoy?.saldoMora || 0),
                0
            )
        }
    },

    methods: {
        formatoNumero(n) {
            return new Intl.NumberFormat('es-HN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(n)
        },
        normalizarEntero(valor, valorDefault = 0) {
            const numero = parseInt(valor, 10)
            return Number.isFinite(numero) ? numero : valorDefault
        },
        normalizarRangoMora(rango) {
            const rangosLegacy = {
                'Al Día': 'AL_DIA',
                'Al día': 'AL_DIA',
                '1-30': 'MORA_1_30',
                '31-60': 'MORA_31_60',
                '61-90': 'MORA_61_90',
                '91-120': 'MORA_91_180',
                '121-150': 'MORA_91_180',
                '151-180': 'MORA_91_180',
                '181-Adelante': 'MORA_181_MAS',
            }

            return rangosLegacy[rango] || rango
        },
        etiquetaRangoMora(codigo) {
            const rangos = {
                AL_DIA: 'Al día',
                MORA_1_30: '1 - 30 días',
                MORA_31_60: '31 - 60 días',
                MORA_61_90: '61 - 90 días',
                MORA_91_180: '91 - 180 días',
                MORA_181_MAS: '181 días en adelante',
            }

            return rangos[codigo] || codigo
        },
        initializeDataTable() {
            const myTable = document.querySelector('#myTable')
            if (myTable) {
                new DataTables(myTable)
            }
        },
        irCredito(dni) {
            this.guardarEnLocalStorage('busqueda', dni);
            window.location.href = '/cartera';
        },
        guardarEnLocalStorage(clave, arrayDeObjetos, tamañoMaximo = 5 * 1024 * 1024) { // 5MB por defecto
            // Convertimos el array de objetos a una cadena JSON
            const jsonString = JSON.stringify(arrayDeObjetos);

            // Calculamos el tamaño del JSON en bytes
            const tamañoJSON = new Blob([jsonString]).size;

            // Verificamos si el tamaño es menor al límite permitido
            if (tamañoJSON <= tamañoMaximo) {
                // Si el tamaño es adecuado, lo guardamos en el localStorage
                localStorage.setItem(clave, jsonString);
            } else {
                console.error(`Error: El array excede el tamaño máximo permitido de ${tamañoMaximo} bytes.`);
            }
        },
    }
}
</script>

<style scoped></style>
